import { render, staticRenderFns } from "./CompanyPanel.vue?vue&type=template&id=3207bf8a&"
import script from "./CompanyPanel.vue?vue&type=script&lang=ts&"
export * from "./CompanyPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports